import { useContext, useEffect, useState } from "react";
import FormInput from "../../components/FormInput";
import AdminSelect from "../../components/AdminSelect";
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import dataApplicationsContext from "../../context/dataApplicationsContext";
import FormDate from "../../components/FormDate";
import { useInsertInscriptionMutation, useSendJustificatifMutation, useUpdateInscriptionMutation } from "../../slices/inscriptionsApiSlice";
import { format } from "date-fns";
import { toast } from "react-toastify";
import SelectPrevUsers from "./SelectPrevUsers";
import { useGetAllPrevUsersQuery } from "../../slices/usersApiSlice";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { pdf } from "@react-pdf/renderer";
import JustificatifPaiementPDF from "./JustificatifPaiementPDF";
import ModalStructure from "../../components/ModalStructure";
import ModaleFacture2 from "./ModaleFacture2";
import { PulseLoader } from "react-spinners";

export default function FormNewUSer({ 
  openModal, setOpenModal, tarifs, paymentMethods, handleCloseModal, id_season, refetch, users, edittingUser, 
  setEdittingUser, selectedSeason, optionGroups
}) { 
  console.log(edittingUser)
  const { data: prevUsers, isLoading: isLoadingUser, isSuccess: isSuccessUser } = useGetAllPrevUsersQuery(
    selectedSeason?.value, { skip: !selectedSeason }
  ); 

  const { openSidebar } = useContext(dataApplicationsContext);

  const [selectedPrevUser, setSelectedPrevUser] = useState(null)
  const [showPdfModal, setShowPdfModal] = useState(false);
  const payeurSchema = yup.object().shape({
    last_name: yup.string().required('Veuillez renseigner le nom du payeur.'),
    first_name: yup.string().required('Veuillez renseigner le prénom du payeur.'),
    email: yup.string().email('Adresse e-mail invalide.').required('Veuillez renseigner un e-mail.'),
    subject: yup.string().required("Veuillez renseigner l'objet du mail."),
    body: yup.string().required('Veuillez renseigner le message du mail.'),
  });

  const pdfForm = useForm({
    resolver: yupResolver(payeurSchema),
    defaultValues: { last_name: '', first_name: '', email: '', subject: '', body: '' }
  });
  const { register: registerPdf, handleSubmit: handleSubmitPdf, reset: resetPdf, formState: { errors: pdfErrors } } = pdfForm;

  const [insertInscription] = useInsertInscriptionMutation();
  const [updateInscription] = useUpdateInscriptionMutation();
  const [sendJustificatif, { isLoading: isSendingPdf }] = useSendJustificatifMutation();

  const handleOpenPdfModal = () => {
    const defaultTutor = (edittingUser?.legal_tutors || watch('tutorsDetails') || [])[0];
    resetPdf({
      last_name: defaultTutor?.tutor_last_name || '',
      first_name: defaultTutor?.tutor_first_name || '',
      email: edittingUser?.email || watch('email') || '',
      subject: `Justificatif de paiement - ${edittingUser?.last_name ?? ''} ${edittingUser?.first_name ?? ''}`,
      body: `Bonjour,\n\nVeuillez trouver ci-joint le justificatif de paiement concernant la saison ${selectedSeason?.label ?? ''}.\n\n` +
        `Cordialement,\nCercle Gymnique Villeneuvois`
    });
    setShowPdfModal(true);
  };
  
  const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // reader.result = "data:application/pdf;base64,XXXXX" → on garde que la partie après la virgule
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });


  const buildJustificatifDoc = (payeurValues) => {
    const tarif = watch("tarif");
    const discount = watch("discount");
    const payments = (watch("paymentsDetails") || [])
      .filter((p) => p.paymentMethod && p.payment_amount)
      .map((p) => ({ method: p.paymentMethod?.label, amount: p.payment_amount, date: p.versement_date }));

    const refunds = (watch("refundsDetails") || [])
      .filter((r) => r.paymentMethod && r.amount_refund)
      .map((r) => ({ method: r.paymentMethod?.label, amount: r.amount_refund, date: r.versement_date, motif: r.motif }));

    const overpayments = (watch("overpaymentsDetails") || [])
      .filter((o) => o.amount_overpayment)
      .map((o) => ({ amount: o.amount_overpayment, motif: o.motif }));

    return (
      <JustificatifPaiementPDF
        user={edittingUser} season={selectedSeason} tarif={tarif} discount={discount}
        payments={payments} refunds={refunds} overpayments={overpayments}
        payeur={{ last_name: payeurValues.last_name, first_name: payeurValues.first_name, email: payeurValues.email }}
        documentDate={new Date()}
        docNumber={`JP-${selectedSeason?.value}-${edittingUser?.id_user_season ?? "NEW"}`}
      />
    );
  };

  const handleGeneratePdf = async (data) => {
    const doc = buildJustificatifDoc(data);
    const blob = await pdf(doc).toBlob();
    const fileName = `justificatif_${edittingUser?.last_name ?? 'gymnaste'}_${selectedSeason?.value ?? ''}_${edittingUser?.id_user_season}.pdf`;

    try {
      const pdfBase64 = await blobToBase64(blob);
      await sendJustificatif({ to: data.email, subject: data.subject, body: data.body, pdfBase64, fileName }).unwrap();
      toast.success("Email envoyé avec succès à " + data.email, { autoClose: 2000 });
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de l'envoi de l'email.");
    }
  };

  const tutorsDetails = edittingUser 
    ? edittingUser.legal_tutors?.map(tutor => {
        const  { tutor_last_name, tutor_first_name, tutor_quality, tutor_job, id_legal_tutor } = tutor;
        return { tutor_last_name, tutor_first_name, tutor_quality, tutor_job, id_legal_tutor }
      })
    : [{ tutor_last_name: '', tutor_first_name: '', tutor_quality: '', tutor_job: '', id_legal_tutor: null }]

  const telephoneDetails = edittingUser?.telephones
    ? edittingUser.telephones.map(tel => {
        const  { lib_telephone, phone_number, id_telephone } = tel;
        return { lib_telephone, phone_number, id_telephone }
      })
    : [{ lib_telephone: 'Père', phone_number: '', id_telephone: null }, { lib_telephone: 'Mère', phone_number: '', id_telephone: null }];


  const optionTarifs = tarifs.map(tarif => {
    const { id_tarif, id_season, lib_tarif, description, birth_year_tarif, is_pre_inscription, created_at, amount } = tarif;
    return (
      { 
        id_tarif, id_season, lib_tarif, description, birth_year_tarif, is_pre_inscription, created_at, amount,
        label: lib_tarif + (birth_year_tarif ? ' / ' + birth_year_tarif : ''), value: id_tarif
      }
    )
  })

  const defaultTrainingGroup = optionGroups.find(group => group.label === "A répartir")
  const optionPaymentMethods = paymentMethods.map(payment => ({ label: payment.lib_payment_method, value: payment.id_payment_method }))

  const defaultValues = {
    last_name: edittingUser?.last_name ?? '',
    first_name: edittingUser?.first_name ?? '',
    code_postal: edittingUser?.code_postal ?? '',
    city: edittingUser?.city ?? '',
    day_of_birth: edittingUser ? format(new Date(edittingUser.birth_date), 'dd') : '',
    month_of_birth: edittingUser ? format(new Date(edittingUser.birth_date), 'MM') : '',
    year_of_birth: edittingUser ? format(new Date(edittingUser.birth_date), 'yyyy') : '',
    adresse: edittingUser ? edittingUser.adresse : '',
    email: edittingUser ? edittingUser.email : '',
    email_2: edittingUser ? edittingUser.email_2 : '',
    discount: edittingUser ? edittingUser.discounts?.[0]?.amount_discount : '',
    discountDetail: edittingUser ? edittingUser.discounts?.[0] : null,
    // is_preInscription: edittingUser ? edittingUser.discounts?.[0]?.amount_discount <= 10 : false,
    user_telephone: edittingUser ? edittingUser.user_telephone : '',
    genderF: edittingUser ? edittingUser.gender.includes('F') : true,
    genderH: edittingUser ? edittingUser.gender.includes('M') : false,
    birth_location: edittingUser?.birth_location ?? 'Villeneuve-sur-lot',
    tarif: edittingUser ? 
      optionTarifs.find(tarif => tarif.id_tarif === edittingUser.id_tarif) || null
      : null,
    trainingGroup: edittingUser ? 
      optionGroups.find(group => group.value === edittingUser.id_group) || defaultTrainingGroup
      : defaultTrainingGroup,
    paymentsDetails: (edittingUser && edittingUser.payments?.[0]?.id_payment_method) ? 
      edittingUser.payments?.map(payment => ({
        id_payment: payment.id_payment,
        paymentMethod: optionPaymentMethods.find(option => option.value === payment.id_payment_method),
        payment_amount: payment.amount,
        versement_date: new Date(payment.versement_date),
        code_reference: payment.code_reference,
      })).filter(payment => payment.paymentMethod) // Filtrer les paiements sans méthode trouvée
      : [{ 
          id_payment: null,
          paymentMethod: null, 
          payment_amount: '', 
          versement_date: null,
          code_reference: ''
        }],
    refundsDetails: (edittingUser && edittingUser.refunds?.[0]?.id_payment_method) ? 
      edittingUser.refunds?.map(refund => ({
        id_refund: refund.id_refund,
        motif: refund.motif,
        paymentMethod: optionPaymentMethods.find(option => option.value === refund.id_payment_method),
        amount_refund: refund.amount_refund,
        versement_date: new Date(refund.versement_date)
      })).filter(refund => refund.paymentMethod) // Filtrer les paiements sans méthode trouvée
      : [{ 
          id_refund: null,
          paymentMethod: null, 
          amount_refund: '', 
          motif: '', 
          versement_date: null
        }],
    overpaymentsDetails: (edittingUser && edittingUser?.overpayments?.[0]?.id_overpayment) ? 
      edittingUser.overpayments?.map(overpayment => ({
        id_overpayment: overpayment.id_overpayment,
        motif: overpayment.motif,
        amount_overpayment: overpayment.amount_overpayment,
      }))
      : [{ 
          id_overpayment: null,
          amount_overpayment: '', 
          motif: '', 
        }],
    tutorsDetails,
    is_image_aggreed: edittingUser ? edittingUser?.is_image_aggreed : true,
    telephoneDetails,
    allergiesDetails: (edittingUser && edittingUser.allergies) 
      ? edittingUser.allergies.map(allergie => ({
          id_allergie: allergie.id_allergie,
          allergie_value: allergie.allergie_value
        }))
      : [{ allergie_value: '', id_allergie: null }],
    fratriesDetails: [{ 
      user: null, 
      showInputs: false,
      genderF: true,
      genderH: false,
    }],
  }

  // Avec cette structure alternative :
  const tutorFields = [
    {label: 'Nom', key: 'tutor_last_name'}, 
    {label: 'Prénom', key: 'tutor_first_name'}, 
    {label: 'Qualité', key: 'tutor_quality'}, 
    {label: 'Profession', key: 'tutor_job'}
  ];

  const telephoneFields = [
    {label: 'Qualité tel', key: 'lib_telephone'}, 
    {label: 'Numéro', key: 'phone_number'}, 
  ];

  const allergieFields = [
    {label: 'Allergie', key: 'allergie_value'}, 
  ];

  const schema = yup.object().shape({
    last_name: yup.string().required('Veuillez renseigner le nom de famille.'),
    first_name: yup.string().required('Veuillez renseigner le prénom.'),
    day_of_birth: yup.string().required('Veuillez renseigner le jour.'),
    month_of_birth: yup.string().required('Veuillez renseigner le mois.'),
    year_of_birth: yup.string().required("Veuillez renseigner l'année."),
    birth_location: yup.string().required("Veuillez renseigner le lieu de naissance"),
    // adresse: yup.string().required("Veuillez renseigner l'adresse postale"),
    tarif: yup.object().typeError("Veuillez sélectionner un tarif.").nullable().required('Veuillez sélectionner un tarif.'),
    trainingGroup: yup.object().typeError("Veuillez sélectionner un groupe.").nullable().required("Veuillez sélectionner un groupe d'entrainement."),
  });

  const newUserForm = useForm({ 
    defaultValues, resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    const {
      tarif, first_name, last_name, genderF, day_of_birth, month_of_birth, adresse, year_of_birth, 
      code_postal, city, user_telephone, email, email_2, birth_location, is_image_aggreed, allergiesDetails, 
      tutorsDetails, telephoneDetails, paymentsDetails, discount, fratriesDetails, has_fratrie, trainingGroup,
      discountDetail, refundsDetails, overpaymentsDetails
    } = data;

    const hasChangedGroup = !edittingUser || edittingUser.id_group !== trainingGroup.value;

    try {
      if (edittingUser) {   // si edition du profil
        await updateInscription({
          id_season, id_tarif: tarif.id_tarif, first_name, last_name: last_name.toUpperCase(), 
          gender: genderF ? 'F' : 'M', hasChangedGroup, 
          birth_date: `${year_of_birth}-${month_of_birth}-${day_of_birth} 12:00:00`,
          adresse: adresse || edittingUser.adresse, code_postal, city, user_telephone, 
          email, email_2, birth_location, is_image_aggreed, 
          has_allergie: allergiesDetails.some(item => item.allergie_value !== ''), 
          tutorsDetails, telephoneDetails, allergiesDetails, paymentsDetails, discount: parseInt(discount, 10),
          fratriesDetails, has_fratrie, id_group: trainingGroup?.value,
          id_user: edittingUser.id_user, 
          refundsDetails, overpaymentsDetails,
          tutorsIDs: edittingUser.legal_tutors.map(tutor => tutor.id_legal_tutor),
          telephonesIDs: edittingUser?.telephones ? edittingUser?.telephones.map(tel => tel.id_telephone) : [],
          paymentsIds: (edittingUser && edittingUser.payments?.[0]?.id_payment_method) 
            ? edittingUser.payments.map(payment => payment.id_payment)
            : [],
          refundsIds: (edittingUser && edittingUser.refunds?.[0]?.id_payment_method) 
            ? edittingUser.refunds.map(refund => refund.id_refund)
            : [],
          overpaymentsIds: (edittingUser && edittingUser.overpayments?.[0]?.id_overpayment) 
            ? edittingUser.overpayments.map(overpayment => overpayment.id_overpayment)
            : [],
          allergiesIds: edittingUser.allergies ? edittingUser.allergies.map(allergie => allergie.id_allergie) : [],
          discountDetail, 
        })
      } else {  // sinon insertion
        await insertInscription({
          id_season, id_tarif: tarif.id_tarif, first_name, last_name: last_name.toUpperCase(), 
          gender: genderF ? 'F' : 'M',
          birth_date: `${year_of_birth}-${month_of_birth}-${day_of_birth} 12:00:00`,
          adresse, code_postal, city, user_telephone, email, email_2, birth_location, is_image_aggreed, 
          has_allergie: allergiesDetails.some(item => item.allergie_value !== ''), 
          tutorsDetails, telephoneDetails, allergiesDetails, paymentsDetails, discount: parseInt(discount, 10),
          fratriesDetails, has_fratrie, id_group: trainingGroup?.value, refundsDetails, overpaymentsDetails
        })
      }
      await setOpenModal(false);
      await refetch();
      setEdittingUser(null)
      window.scroll(0, 0);
      toast.success("Mise à jour réussie", { autoClose: 1000, hideProgressBar: true,});
      reset();
    } catch (error) {
      console.log(error);
      toast.error("Oupss une ereur est survenue...");
    }
  }

  const { register, control, watch, setValue, formState: { errors }, clearErrors, reset, handleSubmit } = newUserForm;

  useEffect(() => {  // pour preremplir la remise si pre-nscription
    if (watch('is_preInscription')) {
      setValue('discount', 10)
    } else if (!edittingUser) {
      setValue('discount', '')
    } else {
      setValue('discount', edittingUser.discounts?.[0]?.amount_discount)
    }
  }, [watch('is_preInscription')])

  const previewLastName = pdfForm.watch('last_name');
  const previewFirstName = pdfForm.watch('first_name');
  const previewEmail = pdfForm.watch('email');

  const previewDoc = showPdfModal
    ? buildJustificatifDoc({ last_name: previewLastName, first_name: previewFirstName, email: previewEmail })
    : null;

  const {fields: tutorsFields, append, remove, replace: replaceTutors} = useFieldArray({
    name: 'tutorsDetails', 
    control
  });
  const {fields: telephonesFields, append: appendTel, remove: removeTel, replace: replaceTel} = useFieldArray({
    name: 'telephoneDetails', 
    control
  });
  const {fields: allergiesFields, append: appendAllergie, remove: removeAllergie, replace: replaceAllergies} = useFieldArray({
    name: 'allergiesDetails', 
    control
  });
  
  // Nouveau useFieldArray pour les paiements seulement
  const {fields: paymentsFields, append: appendPayment, remove: removePayment} = useFieldArray({
    name: 'paymentsDetails',
    control
  });
  // Nouveau useFieldArray pour les remboursements seulement
  const {fields: refundsFields, append: appendRefund, remove: removeRefund} = useFieldArray({
    name: 'refundsDetails',
    control
  });
  const {fields: overpaymentsFields, append: appendOverpayment, remove: removeOverpayment} = useFieldArray({
    name: 'overpaymentsDetails',
    control
  });
  const {fields: fratriesFields, append: appendFratrie, remove: removeFratrie} = useFieldArray({
    name: 'fratriesDetails',
    control
  });

  // useEffect(() => {
  //   if (!openModal) {
  //     reset();  // Réinitialiser le formulaire quand la modale se ferme
  //     clearErrors();
  //   }
  // }, [openModal, reset, clearErrors]);

  useEffect(() => {
    if (openModal) {
      const defaultTrainingGroup = optionGroups.find(g => g.label === "A répartir");
      reset({
        ...defaultValues, // ou reconstruit un objet frais ici
        trainingGroup: edittingUser 
          ? optionGroups.find(g => g.value === edittingUser.id_group) || defaultTrainingGroup
          : defaultTrainingGroup,
        // idem pour tarif, paymentsDetails, etc. si besoin
      });
    }
  }, [openModal, optionGroups, edittingUser]);


  useEffect(() => {
    if (edittingUser) return; // ⬅️ en édition, on ne touche jamais aux champs via ce mécanisme

    if (selectedPrevUser) {
      setValue('last_name', selectedPrevUser.last_name ?? '');
      setValue('first_name', selectedPrevUser.first_name ?? '');
      setValue('adresse', selectedPrevUser.adresse ?? '');
      setValue('code_postal', selectedPrevUser.code_postal ?? '');
      setValue('city', selectedPrevUser.city ?? '');
      setValue('email', selectedPrevUser.email ?? '');
      setValue('email_2', selectedPrevUser.email_2 ?? '');
      setValue('user_telephone', selectedPrevUser.user_telephone ?? '');
      setValue('birth_location', selectedPrevUser.birth_location ?? '');
      setValue('is_image_aggreed', selectedPrevUser.is_image_aggreed ?? true);

      if (selectedPrevUser.birth_date) {
        const birthDate = new Date(selectedPrevUser.birth_date);
        setValue('day_of_birth', format(birthDate, 'dd'));
        setValue('month_of_birth', format(birthDate, 'MM'));
        setValue('year_of_birth', format(birthDate, 'yyyy'));
      }

      const genderValue = (selectedPrevUser.gender || '').trim().toUpperCase();
      setValue('genderF', genderValue === 'F');
      setValue('genderH', genderValue === 'M');

      const tutors = selectedPrevUser.legal_tutors?.length
        ? selectedPrevUser.legal_tutors.map(({ tutor_last_name, tutor_first_name, tutor_quality, tutor_job }) => ({
            tutor_last_name, tutor_first_name, tutor_quality, tutor_job, id_legal_tutor: null,
          }))
        : [{ tutor_last_name: '', tutor_first_name: '', tutor_quality: '', tutor_job: '', id_legal_tutor: null }];
      replaceTutors(tutors);

      const telephones = selectedPrevUser.telephones?.length
        ? selectedPrevUser.telephones.map(({ lib_telephone, phone_number }) => ({
            lib_telephone, phone_number, id_telephone: null,
          }))
        : [{ lib_telephone: 'Père', phone_number: '', id_telephone: null }, { lib_telephone: 'Mère', phone_number: '', id_telephone: null }];
      replaceTel(telephones);

      const allergies = selectedPrevUser.allergies?.length
        ? selectedPrevUser.allergies.map(({ allergie_value }) => ({ allergie_value, id_allergie: null }))
        : [{ allergie_value: '', id_allergie: null }];
      replaceAllergies(allergies);
    } else {
      setValue('last_name', '');
      setValue('first_name', '');
      setValue('adresse', '');
      setValue('code_postal', '');
      setValue('city', '');
      setValue('email', '');
      setValue('email_2', '');
      setValue('user_telephone', '');
      setValue('birth_location', 'Villeneuve-sur-lot');
      setValue('is_image_aggreed', true);
      setValue('day_of_birth', '');
      setValue('month_of_birth', '');
      setValue('year_of_birth', '');
      setValue('genderF', true);
      setValue('genderH', false);

      replaceTutors([{ tutor_last_name: '', tutor_first_name: '', tutor_quality: '', tutor_job: '', id_legal_tutor: null }]);
      replaceTel([{ lib_telephone: 'Père', phone_number: '', id_telephone: null }, { lib_telephone: 'Mère', phone_number: '', id_telephone: null }]);
      replaceAllergies([{ allergie_value: '', id_allergie: null }]);
    }
  }, [selectedPrevUser, edittingUser, setValue, replaceTutors, replaceTel, replaceAllergies]);

  
  const checkboxInputs = (registerName) => {
    const editInputs = [
      {label: 'Garçon', value: watch(registerName + 'genderH'), name: registerName + 'genderH'}, 
      {label: 'Fille', value: watch(registerName + 'genderF'), name: registerName + 'genderF'}, 
    ];
  
    const watchH = watch(registerName + 'genderH');
    const watchF = watch(registerName + 'genderF');

    return (
      <div className="step2-sexe-container flex gap-6 mb-0">
        {editInputs.map((input, index) => {
            let isChecked = input.value;
            return (
              <div className="" key={index}>
                <div className={`line-checkbox-container simpleCheckbox flex gap-2`}>
                  <input 
                    id={input.name} 
                    type='checkbox' 
                    checked={isChecked}
                    disabled={input.locked}
                    onChange={(e) => {
                      if (isChecked && (watchH || watchF)) return // Permet d'eviter la decoche si clic sur la meme checkbox. ex = si valeur homme, si je reclic sur homme, la case reste cochée
                      const { checked } = e.target;
                      editInputs.forEach((item) => { // Permet de gerer le toggle
                        if ((watchH || watchF) && (item.name !== input.name)) {
                          // Décocher toutes les autres cases sauf celle cliquée
                          setValue(item.name, false);
                        }
                      });
                      // // Mettre à jour la valeur de la case cochée
                      setValue(input.name, checked);
                    }}
                  />
                  <label htmlFor={input.name} className={input.locked ? 'op-5' : ''}>
                    <span></span>
                  </label>
                  <label htmlFor={input.name} className={`form-label cursor-pointer`}>{input.label}</label>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }
  
  const showInputsFn = (index, value) => {
    setValue(`fratriesDetails.${index}.showInputs`, value)
  }

  return (
    <div className={`page-container ${openSidebar ? 'open' : 'close'}`}>
      <div className={`pl-16 pr-16 pb-8 max-w-6xl m-auto`}>
        <form onSubmit={handleSubmit(onSubmit)} className={`select-admin-add select-relative flex-gr-1`} noValidate>
          <div className="flex justify-between border-b-2 border-b-zinc-400 pb-6 items-center">
            <p className="text-2xl font-semibold">Information du gymnaste</p>
            <div className="flex gap-8 items-center">
              {edittingUser && (
                isSendingPdf 
                  ? <PulseLoader color="#e1004a" size={8} />
                  : <div className="flex gap-2 items-center cursor-pointer" onClick={handleOpenPdfModal}>
                      <FontAwesomeIcon icon={faFilePdf} className="text-xl"/>
                      <span className="hover:underline">Envoyer une facture</span>
                    </div>
              )}
              <button className="btn-add black" onClick={handleCloseModal}>Fermer</button>
            </div>
          </div>
          <div className="flex justify-between items-center">
            {checkboxInputs('')}
            {!edittingUser && 
              <SelectPrevUsers 
                selectedSeason={selectedSeason} selectedPrevUser={selectedPrevUser} 
                setSelectedPrevUser={setSelectedPrevUser} prevUsers={prevUsers ?? []}
              />
            }
          </div>
          <div className="flex w-full justify-between names">
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-48p"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Nom : ' nameInput={`last_name`} 
              type={'text'} register={register} errors={errors}
              watch={watch} placeholder={'Saisissez le nom'}
            />
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-48p"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Prénom : ' nameInput={`first_name`} 
              type={'text'} register={register} errors={errors}
              watch={watch} placeholder={'Saisissez le nom'}
            />
          </div>
          <div className="flex w-full gap-8 justify-between items-end birth">
            <div className="flex w-1/2 gap-4">
              <FormInput
                nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-25p"} 
                nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                label='Jour' nameInput={`day_of_birth`} type={'number'} register={register} errors={errors}
                watch={watch} placeholder={'05'} min={0} max={31}
              />  
              <FormInput
                nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-25p"} 
                nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                label='Mois' nameInput={`month_of_birth`} type={'number'} register={register} errors={errors}
                watch={watch} placeholder={'02'} min={0} max={12}
              />  
              <FormInput
                nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-25p"} 
                nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                label='Année' nameInput={`year_of_birth`} type={'number'} register={register} errors={errors}
                watch={watch} placeholder={'1991'} min={0} max={2100}
              />  
            </div>
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-1/2"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Lieu de naissance' nameInput={`birth_location`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={'Agen (47)'}
            />  
          </div>
          <div className="flex justify-between gap-6">
            <FormInput
              nameClass={"form-input"} nameClassContainer={"input-admin-container  w-1/2"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Adresse postale' nameInput={`adresse`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={'Saisissez l\'adresse'}
            />  
            <FormInput
              nameClass={"form-input"} nameClassContainer={"input-admin-container  w-1/5"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Code postale' nameInput={`code_postal`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={'Saisissez le code'}
            />  
            <FormInput
              nameClass={"form-input"} nameClassContainer={"input-admin-container  w-1/3"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Ville' nameInput={`city`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={'saisissez la ville'}
            />  
          </div>
          {/* <AddressAutoComplete
            errors={errors} register={register} setValue={setValue} watch={watch} errorClass='mb-16' clearErrors={clearErrors}
            setAdresse={setAdresse}
          /> */}
          <div className="flex gap-8">
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-2/3"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Adresse e-mail - 1' nameInput={`email`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={"Saisissez l'adresse e-mail"}
            /> 
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-1/3"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Téléphone du gymnaste' nameInput={`user_telephone`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={"Saisissez le numéro de téléphone"}
            /> 
          </div>
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-2/3"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Adresse e-mail - 2' nameInput={`email_2`} type={'text'} register={register} errors={errors}
              watch={watch} placeholder={"Saisissez l'adresse e-mail"}
            /> 
          <div className="serparator"></div>
          <p className="text-2xl font-semibold mb-4">Représentant légale <span>(pour les mineurs)</span></p>
          <div className="tutors-name tutors">
            {tutorsFields.map((tutor, tutorIndex) => {
              return (
                <div key={tutor.id} className="tutor-group mb-6">
                  <div className="tutor-fields">
                    {tutorFields.map((field, fieldIndex) => (
                      <div key={fieldIndex}>
                        <FormInput
                          nameClass={"form-input"} 
                          nameClassContainer={"form-input-container items-center"} 
                          nameClassLabel={"form-label mb-4"} 
                          nameClassLabelContainer={"form-label-container"}
                          label={field.label} 
                          nameInput={`tutorsDetails.${tutorIndex}.${field.key}`} 
                          type={'text'} register={register} errors={errors} watch={watch} 
                          placeholder={`Saisissez ${field.label.toLowerCase()}`}
                        /> 
                      </div>
                    ))}
                  </div>
                    
                  {tutorIndex > 0 && (
                    <div className="btn-append" onClick={() => remove(tutorIndex)}>
                      <i className="bi bi-trash3-fill icon-trash cursor-pointer"></i>
                    </div>
                  )}
                </div>
              )
            })}
            <button 
              type="button" className='btn-append' 
              onClick={() => append({ tutor_last_name: '', tutor_first_name: '', tutor_quality: '', tutor_job: '' })}
            >
              <i className="bi bi-plus-lg icon-plus"></i>
            </button>
          </div>
          <div className="tutors-name telephones">
            {telephonesFields.map((item, itemIndex) => {
              return (
                <div key={item.id} className="tutor-group mb-6">
                  <div className="tutor-fields fr-3">
                    {telephoneFields.map((field, fieldIndex) => (
                      <div key={fieldIndex}>
                        <FormInput
                          nameClass={"form-input"} 
                          nameClassContainer={"form-input-container items-center"} 
                          nameClassLabel={"form-label mb-4"} 
                          nameClassLabelContainer={"form-label-container"}
                          label={field.label} 
                          nameInput={`telephoneDetails.${itemIndex}.${field.key}`} 
                          type={'text'} register={register} errors={errors} watch={watch} 
                          placeholder={`Saisissez ${field.label.toLowerCase()}`}
                        /> 
                      </div>
                    ))}
                  </div>
                  {itemIndex > 0 && (
                    <div className="btn-append" onClick={() => removeTel(itemIndex)}>
                      <i className="bi bi-trash3-fill icon-trash cursor-pointer" ></i>
                    </div>
                  )}
                </div>
              )
            })}
            <button 
              type="button" className='btn-append' 
              onClick={() => appendTel({ lib_telephone: '', phone_number: '' })}
            >
              <i className="bi bi-plus-lg icon-plus"></i>
            </button>
          </div> 
          <div className="serparator"></div>
          <p className="text-2xl font-semibold mb-4">Groupe de gymnastique, Paiements & Remboursements</p>
          
          {!edittingUser && 
            <div className={`line-checkbox-container toggle-switch pos-relative w-min mt-0`}>
              <label htmlFor={'is_preInscription'} className={`label-line-checkbox w-fit whitespace-pre flex flex-nowrap mr-8`}>Pré-inscription</label>
              <input id={'is_preInscription'} type="checkbox" className={`switch`} {...register('is_preInscription')}/>
            </div>
          }
          
          <div className="flex">
            <AdminSelect
              control={control} options={optionGroups} name={'trainingGroup'} errors={errors}
              classContainer={`score-select-admin-container w-3/5`} classLabel="label-line-checkbox full-line" 
              classSelect='input-select-container' classNamePrefix="input-select"
              placeholder={'Choisissez un group'} label={'Groupe d\'entrainement'}
            />
          </div>
          
          <div className="flex gap-8">
            <AdminSelect
              control={control} options={optionTarifs} name={'tarif'} errors={errors}
              classContainer={`score-select-admin-container w-3/5`} classLabel="label-line-checkbox full-line" 
              classSelect='input-select-container' classNamePrefix="input-select"
              placeholder={'Choisissez un tarif'} label={'Groupe de tarif'}
            />
            {watch('tarif') && 
              <div className="w-1/5">
                <p className="form-label mb-4">Tarif</p>
                <p className="form-input">{watch('tarif')?.amount}€</p>
              </div>
            }
            <FormInput
              nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-1/5"} 
              nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
              label='Remise en €' nameInput={`discount`} type={'number'} register={register} errors={errors}
              watch={watch} placeholder={"Saisissez remise"}
            /> 
          </div>
          
          {/* Section avec useFieldArray pour les paiements seulement */}
          <div className="payments-container">
            {paymentsFields.map((paymentItem, paymentIndex) => {
              const currentPaymentMethod = watch(`paymentsDetails.${paymentIndex}.paymentMethod`);
              
              return (
                <div key={paymentItem.id} className="payment-group mb-6 relative">
                  <div className="flex gap-8">
                    <AdminSelect
                      control={control}  errors={errors}
                      options={optionPaymentMethods} 
                      name={`paymentsDetails.${paymentIndex}.paymentMethod`}
                      classContainer={`score-select-admin-container w-2/5`} 
                      classLabel="label-line-checkbox full-line" 
                      classSelect='input-select-container' 
                      classNamePrefix="input-select"
                      placeholder={'Choisissez une méthode'} 
                      label={'Méthode de paiement'}
                    />
                    {currentPaymentMethod && 
                      <>
                        <FormInput
                          nameClass={"form-input"} 
                          nameClassContainer={"form-input-container items-center w-1/6"} 
                          nameClassLabel={"form-label mb-4"} 
                          nameClassLabelContainer={"form-label-container"}
                          label='Montant en €' 
                          nameInput={`paymentsDetails.${paymentIndex}.payment_amount`} 
                          type={'number'} 
                          register={register} 
                          errors={errors}
                          watch={watch} 
                          placeholder={"Ex = 80"}
                        /> 
                        <FormDate
                          control={control} 
                          setValue={setValue} 
                          label='Date du paiement' 
                          labelLong='Date du paiement' 
                          labelClass='form-label date mb-4' 
                          noTime 
                          placeholder={"Ex : 26/08/2025"} 
                          noClear
                          nameInput={`paymentsDetails.${paymentIndex}.versement_date`} 
                          dateClass={`date-input w-full`} 
                          errors={errors} 
                          clearErrors={clearErrors}
                          dateContainerClass={`input-admin-container input-calendar-container w-1/4`} 
                          watch={watch}
                        />
                        <FormInput
                          nameClass={"form-input"} 
                          nameClassContainer={"form-input-container items-center w-1/3"} 
                          nameClassLabel={"form-label mb-4"} 
                          nameClassLabelContainer={"form-label-container"}
                          label='Code référence (Optionel)' 
                          nameInput={`paymentsDetails.${paymentIndex}.code_reference`} 
                          type={'text'} 
                          register={register} 
                          errors={errors}
                          watch={watch} 
                          placeholder={"Ex = 26-XZBX-FLMP"}
                        /> 
                      </>
                    }
                  </div>
                  
                  {(paymentIndex > 0 && paymentsFields.length === paymentIndex + 1) && (
                    <div className="btn-append" onClick={() => removePayment(paymentIndex)}>
                      <i className="bi bi-trash3-fill icon-trash cursor-pointer" ></i>
                    </div>
                  )}
                  {(paymentsFields.length !== paymentIndex + 1 || paymentIndex === 0) &&
                    <button 
                      type="button" 
                      className='btn-append' 
                      onClick={() => appendPayment({ 
                        paymentMethod: null, 
                        payment_amount: '', 
                        versement_date: null
                      })}
                    >
                      <i className="bi bi-plus-lg icon-plus"></i>
                    </button>
                  }
                </div>
              )
            })}
          </div>

          {/* Section avec useFieldArray pour les remboursements seulement */}
          <div className="payments-container">
            {refundsFields.map((paymentItem, paymentIndex) => {
              const currentPaymentMethod = watch(`refundsDetails.${paymentIndex}.paymentMethod`);
              
              return (
                <div key={paymentItem.id} className="payment-group mb-6 relative">
                  <div className="flex gap-8 mb-4">
                    <AdminSelect
                      control={control}  errors={errors}
                      options={optionPaymentMethods} 
                      name={`refundsDetails.${paymentIndex}.paymentMethod`}
                      classContainer={`score-select-admin-container w-3/5`} 
                      classLabel="label-line-checkbox full-line" 
                      classSelect='input-select-container' 
                      classNamePrefix="input-select"
                      placeholder={'Choisissez une méthode'} 
                      label={'Méthode de remboursement'}
                    />
                    {currentPaymentMethod && 
                      <>
                        <FormInput
                          nameClass={"form-input"} 
                          nameClassContainer={"form-input-container items-center w-1/5"} 
                          nameClassLabel={"form-label mb-4"} 
                          nameClassLabelContainer={"form-label-container"}
                          label='Montant en €' 
                          nameInput={`refundsDetails.${paymentIndex}.amount_refund`} 
                          type={'number'} 
                          register={register} 
                          errors={errors}
                          watch={watch} 
                          placeholder={"Ex = 80"}
                        /> 
                        <FormDate
                          control={control} 
                          setValue={setValue} 
                          label='Date du paiement' 
                          labelLong='Date du paiement' 
                          labelClass='form-label date mb-4' 
                          noTime 
                          placeholder={"Ex : 26/08/2025"} 
                          noClear
                          nameInput={`refundsDetails.${paymentIndex}.versement_date`} 
                          dateClass={`date-input w-full`} 
                          errors={errors} 
                          clearErrors={clearErrors}
                          dateContainerClass={`input-admin-container input-calendar-container w-1/4`} 
                          watch={watch}
                        />
                      </>
                    }
                  </div>
                  <FormInput
                    nameClass={"form-input"} 
                    nameClassContainer={"form-input-container items-center w-full"} 
                    nameClassLabel={"form-label mb-4"} 
                    nameClassLabelContainer={"form-label-container"}
                    label='Motif (optionnel)' 
                    nameInput={`refundsDetails.${paymentIndex}.motif`} 
                    type={'text'} 
                    register={register} 
                    errors={errors}
                    watch={watch} 
                    placeholder={"Saisissez un motif"}
                  /> 
                  
                  {(paymentIndex > 0 && refundsFields.length === paymentIndex + 1) && (
                    <div className="btn-append" onClick={() => removeRefund(paymentIndex)}>
                      <i className="bi bi-trash3-fill icon-trash cursor-pointer" ></i>
                    </div>
                  )}
                  {(refundsFields.length !== paymentIndex + 1 || paymentIndex === 0) &&
                    <button 
                      type="button" 
                      className='btn-append' 
                      onClick={() => appendRefund({ 
                        paymentMethod: null, 
                        payment_amount: '', 
                        versement_date: null
                      })}
                    >
                      <i className="bi bi-plus-lg icon-plus"></i>
                    </button>
                  }
                </div>
              )
            })}
          </div>

          {/* {!edittingUser && 
            <div className="fratrie-container">
              <div className={`line-checkbox-container toggle-switch pos-relative w-min mt-8`}>
                <label htmlFor={'has_fratrie'} className={`label-line-checkbox w-fit whitespace-pre flex flex-nowrap mr-8`}>
                  Associé un frère ou sœur
                </label>
                <input id={'has_fratrie'} type="checkbox" className={`switch`} {...register('has_fratrie')}/>
              </div>
              {watch('has_fratrie') && 
                <div className="mt-8">
                  {fratriesFields.map((fratrieItem, fratrieIndex) => {
                    const showInputs = watch(`fratriesDetails.${fratrieIndex}.showInputs`);
                    
                    return (
                      <div key={fratrieItem.id} className={`fratrie-group mb-6 relative ${fratrieIndex > 0 ? 'mt-16' : ''}`}>
                        {!showInputs && 
                          <div className="flex gap-8 items-end">
                            <AdminSelect
                              control={control} options={users} name={`fratriesDetails.${fratrieIndex}.user`} errors={errors}
                              classContainer={`score-select-admin-container w-3/5 mt-0 mb-0`} classLabel="label-line-checkbox full-line" 
                              classSelect='input-select-container' classNamePrefix="input-select"
                              placeholder={'Choisissez un gymnaste'} label={'Gymnaste déjà inscrit'}
                            /> 
                            <p className="font-semibold underline underline-offset-2 cursor-pointer" 
                              onClick={() => showInputsFn(fratrieIndex, true)}
                            >
                              Saisir les infos du gymnaste
                            </p>
                          </div>
                        }
                        {showInputs && 
                          <div className="saisie-info-fratrie">
                            <div className="flex items-end justify-between mb-8">
                              {checkboxInputs(`fratriesDetails.${fratrieIndex}.`)}
                              <p className="font-semibold underline underline-offset-2 cursor-pointer" 
                                onClick={() => showInputsFn(fratrieIndex, false)}
                              >
                                Choisir un gymnaste dans la liste
                              </p>
                            </div>
                            <div className="flex w-full justify-between names">
                              <FormInput
                                nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-48p"} 
                                nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                                label='Nom : ' nameInput={`fratriesDetails.${fratrieIndex}.last_name`} 
                                type={'text'} register={register} errors={errors}
                                watch={watch} placeholder={'Saisissez le nom'}
                              />
                              <FormInput
                                nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-48p"} 
                                nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                                label='Prénom : ' nameInput={`fratriesDetails.${fratrieIndex}.first_name`} 
                                type={'text'} register={register} errors={errors}
                                watch={watch} placeholder={'Saisissez le prénom'}
                              />
                            </div>
                            <div className="flex w-full gap-8 justify-between items-end birth mt-6">
                              <div className="flex w-1/2 gap-4">
                                <FormInput
                                  nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-25p"} 
                                  nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                                  label='Jour' nameInput={`fratriesDetails.${fratrieIndex}.day_of_birth`} type={'number'} 
                                  register={register} errors={errors}
                                  watch={watch} placeholder={'05'} min={0} max={31}
                                />  
                                <FormInput
                                  nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-25p"} 
                                  nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                                  label='Mois' nameInput={`fratriesDetails.${fratrieIndex}.month_of_birth`} type={'number'} 
                                  register={register} errors={errors}
                                  watch={watch} placeholder={'02'} min={0} max={12}
                                />  
                                <FormInput
                                  nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-25p"} 
                                  nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                                  label='Année' nameInput={`fratriesDetails.${fratrieIndex}.year_of_birth`} type={'number'} 
                                  register={register} errors={errors}
                                  watch={watch} placeholder={'1991'} min={0} max={2100}
                                />  
                              </div>
                              <FormInput
                                nameClass={"form-input"} nameClassContainer={"form-input-container items-center w-1/2"} 
                                nameClassLabel={"form-label mb-4"} nameClassLabelContainer={"form-label-container"}
                                label='Lieu de naissance' nameInput={`fratriesDetails.${fratrieIndex}.birth_location`} type={'text'} 
                                register={register} errors={errors}
                                watch={watch} placeholder={'Agen (47)'}
                              />  
                            </div>
                          </div>
                        }
                        <AdminSelect
                          control={control} options={optionTarifs} name={`fratriesDetails.${fratrieIndex}.tarif`} errors={errors}
                          classContainer={`score-select-admin-container w-3/5 mt-8`} classLabel="label-line-checkbox full-line" 
                          classSelect='input-select-container' classNamePrefix="input-select"
                          placeholder={'Choisissez un tarif'} label={'Groupe'}
                        />

                        
                        {(fratrieIndex > 0 && fratriesFields.length === fratrieIndex + 1) && (
                          <div className="btn-append" onClick={() => removeFratrie(fratrieIndex)}>
                            <i className="bi bi-trash3-fill icon-trash cursor-pointer"></i>
                          </div>
                        )}
                        {(fratriesFields.length !== fratrieIndex + 1 || fratrieIndex === 0) &&
                          <button 
                            type="button" 
                            className='btn-append' 
                            onClick={() => appendFratrie({ 
                              user: null, 
                              showInputs: false,
                              genderF: true,
                              genderH: false,
                            })}
                          >
                            <i className="bi bi-plus-lg icon-plus"></i>
                          </button>
                        }
                      </div>
                    )
                  })}
                </div>
              }
            </div>
          } */}


          <div className="serparator"></div>
          {/* Section avec useFieldArray pour les remboursements seulement */}
          <div className="overpayments-container relative">
            <p className="text-2xl font-semibold mb-6">Trop perçu et régulation du solde</p>
            {overpaymentsFields.map((overpaymentItem, overpaymentIndex) => {              
              return (
                <div key={overpaymentItem.id} className="overpayment-group mb-6 relative">
                  <div className="flex gap-8 mb-4">
                    <FormInput
                      nameClass={"form-input"} 
                      nameClassContainer={"form-input-container items-center w-1/5"} 
                      nameClassLabel={"form-label mb-4"} 
                      nameClassLabelContainer={"form-label-container"}
                      label='Montant en €' 
                      nameInput={`overpaymentsDetails.${overpaymentIndex}.amount_overpayment`} 
                      type={'number'} 
                      register={register} 
                      errors={errors}
                      watch={watch} 
                      placeholder={"Ex = 80"}
                    /> 
                    <FormInput
                      nameClass={"form-input"} 
                      nameClassContainer={"form-input-container items-center w-full"} 
                      nameClassLabel={"form-label mb-4"} 
                      nameClassLabelContainer={"form-label-container"}
                      label='Motif (optionnel)' 
                      nameInput={`overpaymentsDetails.${overpaymentIndex}.motif`} 
                      type={'text'} 
                      register={register} 
                      errors={errors}
                      watch={watch} 
                      placeholder={"Saisissez un motif"}
                    /> 
                  </div>
                  
                  {(edittingUser?.overpayments?.[0]?.id_overpayment || overpaymentIndex > 0) &&
                    <div 
                      className={`btn-append ${overpaymentIndex === 0 ? 'right--4' : ''}`} 
                      onClick={() => removeOverpayment(overpaymentIndex)}
                    >
                      <i className="bi bi-trash3-fill icon-trash cursor-pointer" ></i>
                    </div>
                  }
                </div>
              )
            })}
            <button 
              type="button" 
              className={`btn-append ${overpaymentsFields.length === 0 ? 'fist-position' : 'standard'}` }
              onClick={() => appendOverpayment({ 
                id_overpayment: null,
                amount_overpayment: '', 
                motif: '', 
                created_at: null
              })}
            >
              <i className="bi bi-plus-lg icon-plus"></i>
            </button>
          </div>
          
          <div className="serparator"></div>
          <div className="flex gap-8">
            <div className="w-1/2">
              <p className="text-2xl font-semibold mb-4">Questionnaire de santé</p>
              <div className="tutors-name allergies">
                {allergiesFields.map((item, itemIndex) => {
                  return (
                    <div key={item.id} className="tutor-group mb-6">
                      <div className="tutor-fields fr-1">
                        {allergieFields.map((field, fieldIndex) => (
                          <div key={fieldIndex}>
                            <FormInput
                              nameClass={"form-input"} 
                              nameClassContainer={"form-input-container items-center"} 
                              nameClassLabel={"form-label mb-4"} 
                              nameClassLabelContainer={"form-label-container"}
                              label={field.label} 
                              nameInput={`allergiesDetails.${itemIndex}.${field.key}`} 
                              type={'text'} register={register} errors={errors} watch={watch} 
                              placeholder={`Saisissez ${field.label.toLowerCase()}`}
                            /> 
                          </div>
                        ))}
                      </div>
                        
                      {itemIndex > 0 && (
                        <div className="btn-append" onClick={() => removeAllergie(itemIndex)}>
                          <i className="bi bi-trash3-fill icon-trash cursor-pointer"></i>
                        </div>
                      )}
                    </div>
                  )
                })}
                <button 
                  type="button" className='btn-append' 
                  onClick={() => appendAllergie({ allergie_value: ''})}
                >
                  <i className="bi bi-plus-lg icon-plus"></i>
                </button>
              </div> 
            </div>
            <div className="w-1/2 ml-32">
              <p className="text-2xl font-semibold mb-4">Droit à l'image</p>
              <div className={`line-checkbox-container toggle-switch pos-relative w-min mt-0`}>
                <label htmlFor={'is_image_aggreed'} className={`label-line-checkbox w-fit whitespace-pre flex flex-nowrap mr-8`}>Autorise les droits d'image</label>
                <input id={'is_image_aggreed'} type="checkbox" className={`switch`} {...register('is_image_aggreed')}/>
              </div>
            </div>
          </div>
          <div className="serparator mb-0"></div>
          <div className="part-submit gap-6">
            <button onClick={handleCloseModal} className={`btn-add py-4`}>Annuler</button>
            <button type="submit" className={`btn-add black py-4`}>{edittingUser ? 'Modifier' : 'Ajouter'} l'inscription</button>
          </div>
        </form>
      </div>
      <ModalStructure
        openModal={showPdfModal} setOpenModal={setShowPdfModal} isSubmitting={isSendingPdf}
        title="Informations pour envoi mail justificatif" titleClass="font-bold text-2xl text-center"
        btnText="Envoyer e-mail" cancelText="Annuler"
        wrapperClass="pdf-modal-wrapper"
        onSubmit={handleSubmitPdf(async (data) => {
          await handleGeneratePdf(data);
          setShowPdfModal(false);
        })}
        body={
          showPdfModal && (
            <ModaleFacture2 register={registerPdf} errors={pdfErrors} pdfDocument={previewDoc} />
          )
        }
      />
    </div>
  )
}